
import { TestDetails } from "@/hooks/test-creator/useTestDetails";
import { TestDetailsSection } from "../test-creator-sections/TestDetailsSection";
import { Button } from "@/components/ui/button";
import { Wand2, Loader2 } from "lucide-react";
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { Question } from "@/types/test";
import { InfoBox } from "@/components/shared/InfoBox";
import { useIsMobile } from "@/hooks/use-mobile";
import { SkillBasedGenerationDialog } from "../SkillBasedGenerationDialog";

interface TestDetailsScreenProps {
  details: TestDetails;
  onChange: (details: TestDetails) => void;
  onNext: () => void;
  onGenerateQuestions?: (questions: Question[]) => void;
}

export const TestDetailsScreen = ({
  details,
  onChange,
  onNext,
  onGenerateQuestions,
}: TestDetailsScreenProps) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const { toast } = useToast();
  const isMobile = useIsMobile();

  const canProceed = Boolean(
    details.title &&
    details.description
  );

  const handleGenerateQuestions = async (questions: Question[]) => {
    try {
      setIsGenerating(true);
      console.log('Generated questions:', questions);
      
      if (questions && questions.length > 0) {
        if (onGenerateQuestions) {
          onGenerateQuestions(questions);
        }
        onNext();
      } else {
        throw new Error('No questions were generated');
      }
    } catch (error: any) {
      console.error('Error handling generated questions:', error);
      toast({
        title: "Error with generated questions",
        description: error.message || "Please try again",
        variant: "destructive",
      });
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className={`space-y-8 ${isMobile ? 'pb-24' : ''}`}>
      <InfoBox 
        title="Provide Accurate Role Information" 
        className="bg-blue-50 border-blue-200 dark:bg-blue-900/20 dark:border-blue-800"
      >
        Clear, detailed job descriptions help create more relevant tests and attract better candidates. 
        Ensure your role details accurately reflect your team's requirements.
      </InfoBox>
      
      <TestDetailsSection
        details={details}
        onChange={onChange}
      />
      <div className={`flex ${isMobile ? "justify-center mt-8 mb-10" : "justify-end mb-8"}`}>
        <SkillBasedGenerationDialog
          details={details}
          onGenerateQuestions={handleGenerateQuestions}
          loading={isGenerating}
          disabled={!canProceed || isGenerating}
        />
      </div>
    </div>
  );
};
